import React from 'react';
import Particles from 'react-tsparticles';

import {lineBg} from 'assets';
import {loadFull} from 'tsparticles';
import type {Container, Engine} from 'tsparticles-engine';

import './style.scss';

const AnimatedBackground = () => {
	const particlesInit = async (engine: Engine): Promise<void> => {
		await loadFull(engine);
	};

	// @ts-ignore
	const particlesLoaded = (container?: Container | undefined): Promise<any> => {};

	return (
		<Particles
			id="animatedBackground"
			init={particlesInit}
			loaded={particlesLoaded}
			options={lineBg}
		/>
	);
};

export default AnimatedBackground;
